import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/sass/main.scss';
import './index.css';
import App from './App';
import { loadConfig } from '@/config';
import './i18n/config';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
const container = document.getElementById('root');
if (!container)
    throw new Error('Root container missing in index.html');
const root = createRoot(container);
// Load config before rendering the app
loadConfig()
    .then(() => {
    root.render(_jsx(React.StrictMode, { children: _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(App, {}) }) }));
})
    .catch(error => {
    console.error('Failed to load application config:', error);
    root.render(_jsx("div", { style: { padding: '20px', color: 'red' }, children: "Failed to load application configuration. Please contact support." }));
});
